import type { brand } from "./brand";
import type { Condition, ProductType, ValuesOf } from "./enums";
import { id } from "./id";
import type { Product } from "./product";

export interface order_detail {
    id: string;
    sellerId: number;
    buyerId: number;
    orderId: number;
    itemId: number;
    brandId: number;
    productId: number;
    quantity: number;
    condition: ValuesOf<typeof Condition>;
    satisfaction?: number;
    review?: string;
}

export interface OrderDetail extends order_detail {
    name: string;
    brand: string;
    type: ValuesOf<typeof ProductType>;
    image?: string;
    brandImage?: string;
}

export const orderDetailToProduct = (x: OrderDetail): Product =>
    ({
        id: id(x.brandId, x.productId),
        brandId: x.brandId,
        productId: x.productId!,
        name: x.name!,
        type: x.type,
    }) as Product;

export const orderDetailToBrand = (x: OrderDetail): brand =>
    ({
        id: id(x.brandId),
        brandId: x.brandId,
        name: x.brand,
        image: x.brandImage,
    }) as brand;
